export const xlat = {
    "HEADER_NOT_PROVIDED": "Internal error: HTTP Authorization header not provided",
    "DEVICE_NOT_AUTHORIZED": "Internal error: Device no longer authorized",
    "BEARER_TOKEN_REQUIRED": "Internal error: Unique key not provided",
    "USER_EMAIL_ALREADY_EXISTS": "User email already exists",
    "UNDELETABLE_USER": "User cannot be deleted",
    "BUSINESS_NAME_ALREADY_EXISTS": "Business name already exists",
    "BUSINESS_INSUFFICIENT_FUNDS": "Business has insufficient funds",
    "DEVICE_ALREADY_ACTIVATED": "Device already activated",
    "DEVICE_NOT_ACTIVATED": "Device not yet activated",
    "UNDELETABLE_DEVICE": "Device cannot be deleted",
    "REGISTRATION_EXPENDED": "Registration expended",
    "CARD_INSUFFICIENT_FUNDS": "Card has insufficient funds",
    "UNCREDITABLE_CARD": "Card cannot be credited",
    "UNDEBITABLE_CARD": "Card cannot be debited",
    "UNLINKABLE_CARD": "Card cannot be linked",
    "CARD_ALREADY_LINKED": "Card already linked",
    "CARD_ALREADY_UNLINKED": "Card already unlinked",
    "TRANSACTION_ALREADY_CANCELLED": "Transaction already cancelled",
    "TRANSACTION_CANCELLATION_EXPIRED": "Transaction cancellation expired",
    "UNCANCELLABLE_TRANSACTION": "Transaction cannot be cancelled",
    "OVERDRAFT_LIMIT_ALREADY_EXISTS": "Overdraft limit already exists",
    "CARD_ATTACHMENT_ALREADY_EXISTS": "Card attachment already exists",
    "CARD_ATTACHMENT_ALREADY_DELETED": "Card attachment already deleted",
    "INSUFFICIENT_PRIVILEGES": "Your access role cannot execute this action",
    "USER_NOT_FOUND": "User not found",
    "USER_DELETED": "User deleted",
    "BUSINESS_NOT_FOUND": "Business not found",
    "DEVICE_NOT_FOUND": "Device not found",
    "DEVICE_DELETED": "Device deleted",
    "REGISTRATION_NOT_FOUND": "Registration not found",
    "REGISTRATION_EXPIRED": "Registration expired",
    "CARD_NOT_FOUND": "Card not found",
    "TRANSACTION_NOT_FOUND": "Transaction not found",
    "OVERDRAFT_LIMIT_NOT_FOUND": "Overdraft limit not found",
    "CARD_ATTACHMENT_NOT_FOUND": "Card attachment not found",
    "INVALID_USER_EMAIL": "Invalid user email",
    "INVALID_USER_FIRST_NAME": "Invalid user first name",
    "INVALID_USER_LAST_NAME": "Invalid user last name",
    "INVALID_BUSINESS_NAME": "Invalid business name",
    "INVALID_BUSINESS_LOGO_URL": "Invalid business logo URL",
    "INVALID_DEVICE_NAME": "Invalid device name",
    "INVALID_BUSINESS_CREDIT_TRANSACTION_AMOUNT": "Amount must be between CHF 0.00 and CHF 2500.00",
    "INVALID_CARD_CREDIT_TRANSACTION_AMOUNT": "Amount must be between CHF 0.00 and CHF 250.00",
    "INVALID_CARD_DEBIT_TRANSACTION_AMOUNT": "Amount must be between CHF 0.00 and CHF 250.00",
    "INVALID_BUSINESS_OVERDRAFT_LIMIT_AMOUNT": "Amount must be greater than CHF 0.00",
    "INVALID_CARD_ATTACHMENT_TYPE": "Invalid card attachment type",
    "INVALID_CARD_ATTACHMENT_URL": "Invalid card attachment URL",
    "INVALID_CARD_ATTACHMENT_VIDEO_URL": "Invalid card attachment video URL",
    "INVALID_CARD_ATTACHMENT_THUMBNAIL_URL": "Invalid card attachment thumbnail URL",
    "INVALID_CARD_ATTACHMENT_EXPIRY": "Invalid timespan for the automatic video expiry (1…52 weeks)"
};
//# sourceMappingURL=index.js.map